<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">筛选</h1>-->
    <!--</header>-->
    <div class="mui-content">
      <div class="title-name">
        <span class="">筛选</span>
      </div>
      <div style="margin-top: 15px;">
        <!--第一行-->
        <div class="form-group">
          <div class="input-label">
            <label>物料名称:</label>
          </div>
          <div class="form-input">
            <input type="text" maxlength="60" v-model="scxtwpmc" />
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">指示日期:</label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 4;" :data-options='dataoptions' v-model="schedate_fr" @tap="showpicker(1)" />
            <span class="input-label" style="flex:5;text-align: center;">
                （开始）
              </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label"></label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 4;" :data-options='dataoptions' v-model="schedate_to" @tap="showpicker(2)" />
            <span class="input-label" style="flex:5;text-align: center;">
                （结束）
              </span>
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label>状态:</label>
          </div>
          <div class="form-input">
            <select v-model="statusflg">
              <option value="">全部</option>
              <option value="1">未完成</option>
              <option value="0">已完成</option>
            </select>
          </div>
        </div>
        <div class="form-group" style="width:100%;margin-top: 30px;">
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" @tap="query">筛选</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "deliveryQuery",
  data() {
    return {
      scxtwpmc: "",
      dataoptions: '{"type":"date"}',
      schedate_fr: "",
      schedate_to: "",
      statusflg: "1" // 0 已完成 1 未完成
    }
  },
  watch:{
    scxtwpmc:function(val){
      //this.scxtwpmc = isText(val);
      this.scxtwpmc = val;
    }
  },
  created() {},
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.scxtwpmc = para.scxtwpmc;
      v.schedate_fr = para.schedate_fr;
      v.schedate_to = para.schedate_to;
      v.statusflg = para.statusflg; // 0 已完成 1 未完成
    } else {
      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date);
      date.setDate(date.getDate() - 7); //设置天数 -7 天
      var from_date = v.getFormatDate(date);
      v.scxtwpmc = "";
      v.schedate_fr = from_date;
      v.schedate_to = now_date;
      v.statusflg = "1"; // 0 已完成 1 未完成
    }
  },
  methods: {
    showpicker(type) {
      var v = this;
      var dDate = new Date();
      var optionsJson = v.dataoptions;
      var options = JSON.parse(optionsJson);
      var picker = new mui.DtPicker(options);
      picker.show(function(rs) {
        console.log(rs)
        var timestr = rs.text;
        if (type == 1) {
          v.schedate_fr = timestr.replace(/-/g, "/");
        } else if (type == 2) {
          v.schedate_to = timestr.replace(/-/g, "/");
        }
        picker.dispose();
      });
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    query() {
      var v = this;
      var deinfo = {
        scxtwpmc: v.scxtwpmc,
        schedate_fr: v.schedate_fr,
        schedate_to: v.schedate_to,
        statusflg: v.statusflg // 0 已完成 1 未完成
      };
      v.eventBus.$emit('deinfo', deinfo);
      v.$router.go(-1);
    }
  }
}
</script>
<style scoped>
@import "../../static/css/filterorder.css";
</style>



// WEBPACK FOOTER //
// src/components/deliveryQuery.vue